import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6a9d7092"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "login"
}, "登录", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("a", {
    class: "logout-container",
    onClick: $setup.loginHandler
  }, [_createElementVNode("img", {
    class: "avatar",
    src: require('./ic_normal.png')
  }, null, 8, _hoisted_1), _hoisted_2]), $setup.showLoginPanel ? (_openBlock(), _createBlock($setup["LoginPanel"], {
    key: 0,
    redirectUrl: $setup.redirectUrl,
    onCloseclick: $setup.closeHandler,
    onLoginsuccess: $setup.loginSuccessHandler
  }, null, 8, ["redirectUrl"])) : _createCommentVNode("", true)], 64);
}